import React from 'react';
import { INPUT_MAP } from './form.config';

import { FORM_KEYS } from './form.keys';
import {
  DisabledRatioSelectorOptions,
  FixedRatios,
  RatioSelectorOptions,
} from '@model';
import { Tooltip } from 'antd';

export const flexStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const checkBoxStyle = {
  ...flexStyle,
  maxHeight: '5rem',
};

export const columns = [
  {
    title: (
      <div className="col-title">
        <span />
      </div>
    ),
    dataIndex: FORM_KEYS.DRAG.key,
    key: FORM_KEYS.DRAG.key,
    style: { ...checkBoxStyle, width: '3rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.DRAG.key] },
  },
  {
    title: (
      <div className="col-title left pl15">
        <span className="is-required">{FORM_KEYS.MODULE.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.MODULE.key,
    key: FORM_KEYS.MODULE.key,
    style: { width: '15rem' },

    formConfig: { ...INPUT_MAP[FORM_KEYS.MODULE.key] },
  },
  {
    title: (
      <div className="col-title">
        <span>{FORM_KEYS.TYPE.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.TYPE.key,
    key: FORM_KEYS.TYPE.key,
    style: { ...checkBoxStyle, width: '6.2rem', textAlign: 'center' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.TYPE.key] },
  },

  {
    title: (
      <div className="col-title">
        <span>{FORM_KEYS.IFRAME.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.IFRAME.key,
    key: FORM_KEYS.IFRAME.key,
    style: { ...checkBoxStyle, width: '5rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.IFRAME.key] },
  },
  {
    title: (
      <div className="col-title">
        <span>{FORM_KEYS.ICON.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.ICON.key,
    key: FORM_KEYS.ICON.key,
    style: { width: '7rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.ICON.key] },
  },
  {
    title: (
      <div className="col-title">
        <span>Report Ratio</span>
      </div>
    ),
    dataIndex: 'ratio',
    key: 'ratio',
    style: { ...checkBoxStyle, width: '12.5rem' },
    formConfig: {
      ...INPUT_MAP[FORM_KEYS.RATIO.key],
      // disabled: isDefault,
      options: RatioSelectorOptions,
      defaultValue: FixedRatios.FULL,
      className: 'section-ratio-select',
      shouldRefRowData: true,
    },
  },
  {
    title: (
      <div className="col-title left pl15">
        <span>{FORM_KEYS.LINK.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.LINK.key,
    key: FORM_KEYS.LINK.key,
    style: { width: '12.875rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.LINK.key] },

    //
  },
  {
    title: (
      <div className="col-title left pl15">
        <span>{FORM_KEYS.MSECTION.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.MSECTION.key,
    key: FORM_KEYS.MSECTION.key,
    style: { width: '16.5rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.MSECTION.key] },

    //
  },
  {
    title: (
      <div className="col-title">
        <span>{FORM_KEYS.INTERNAL.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.INTERNAL.key,
    key: FORM_KEYS.INTERNAL.key,

    formConfig: { ...INPUT_MAP[FORM_KEYS.INTERNAL.key] },
    style: { width: '5rem', ...flexStyle },
  },
  {
    title: (
      <div className="col-title">
        <span>{FORM_KEYS.CLIENT.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.CLIENT.key,
    key: FORM_KEYS.CLIENT.key,
    formConfig: { ...INPUT_MAP[FORM_KEYS.CLIENT.key] },
    style: { width: '5rem', ...flexStyle },
    // style: { flexShrink: 1 },
  },
  {
    dataIndex: FORM_KEYS.DELETE.key,
    key: FORM_KEYS.DELETE.key,
    style: {
      ...flexStyle,
      width: '2.25rem',
      padding: '0.625rem 0rem 0.625rem 0.625rem',
    },
    formConfig: { ...INPUT_MAP[FORM_KEYS.DELETE.key] },

    //
  },
];
export const defaultColumns = [
  {
    title: (
      <div className="col-title">
        <span />
      </div>
    ),
    dataIndex: FORM_KEYS.DRAG.key,
    key: FORM_KEYS.DRAG.key,
    style: { ...checkBoxStyle, width: '3rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.DRAG.key] },
  },
  {
    title: (
      <div className="col-title left pl15">
        <span className="is-required">{FORM_KEYS.MODULE.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.MODULE.key,
    key: FORM_KEYS.MODULE.key,
    style: { width: '15rem' },
    className: 'not-align-item',
    formConfig: { ...INPUT_MAP[FORM_KEYS.MODULE.key] },
  },
  {
    title: (
      <div className="col-title">
        <span>{FORM_KEYS.TYPE.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.TYPE.key,
    key: FORM_KEYS.TYPE.key,
    style: { ...checkBoxStyle, width: '6.2rem', textAlign: 'center' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.TYPE.key] },
  },

  {
    title: (
      <div className="col-title">
        <span>{FORM_KEYS.IFRAME.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.IFRAME.key,
    key: FORM_KEYS.IFRAME.key,
    style: { ...checkBoxStyle, width: '5rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.IFRAME.key], disabled: true },
  },
  {
    title: (
      <div className="col-title">
        <span>{FORM_KEYS.ICON.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.ICON.key,
    key: FORM_KEYS.ICON.key,
    className: 'not-align-item',
    style: { width: '7rem' },
    // formConfig: { ...INPUT_MAP[FORM_KEYS.ICON.key] },
    formConfig: { ...INPUT_MAP[FORM_KEYS.ICON.key], disabled: true },
  },
  {
    title: (
      <div className="col-title">
        <span>Report Ratio</span>
      </div>
    ),
    dataIndex: 'ratio',
    key: 'ratio',
    style: { ...checkBoxStyle, width: '12.5rem' },
    formConfig: {
      ...INPUT_MAP[FORM_KEYS.RATIO.key],
      disabled: true,
      options: DisabledRatioSelectorOptions,
      defaultValue: FixedRatios.NONE,
      className: 'section-ratio-select',
    },
  },
  {
    title: (
      <div className="col-title left pl15">
        <span>{FORM_KEYS.DLINK.label}</span>
      </div>
    ),
    // dataIndex: FORM_KEYS.LINK.key,
    key: FORM_KEYS.DLINK.key,
    className: 'not-align-item',
    style: { width: '12.875rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.DLINK.key] },

    //
  },
  {
    title: (
      <div className="col-title left pl15">
        <span>{FORM_KEYS.MSECTION.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.MSECTION.key,
    // key: FORM_KEYS.MSECTION.key,
    style: { width: '16.5rem' },
    className: 'not-align-item',

    formConfig: { ...INPUT_MAP[FORM_KEYS.MSECTION.key] },

    //
  },
  {
    title: (
      <div className="col-title">
        <span>{FORM_KEYS.INTERNAL.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.INTERNAL.key,
    key: FORM_KEYS.INTERNAL.key,
    formConfig: { ...INPUT_MAP[FORM_KEYS.INTERNAL.key] },
    style: { width: '5rem', ...flexStyle },
  },
  {
    title: (
      <div className="col-title">
        <span>{FORM_KEYS.CLIENT.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.CLIENT.key,
    key: FORM_KEYS.CLIENT.key,
    formConfig: { ...INPUT_MAP[FORM_KEYS.CLIENT.key] },
    style: { width: '5rem', ...flexStyle },
    // style: { flexShrink: 1 },
  },
];
export const projectSettingDefaultColumns = [
  ...defaultColumns.slice(0, 7),
  {
    title: (
      <div className="col-title left pl15">
        <span>{FORM_KEYS.SECTION_LIST.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.SECTION_LIST.key,
    key: FORM_KEYS.SECTION_LIST.key,
    style: { width: '16.5rem' },
    className: 'not-align-item',

    formConfig: { ...INPUT_MAP[FORM_KEYS.SECTION_LIST.key] },
  },
  {
    title: (
      <div className="col-title">
        <span>{FORM_KEYS.INTERNAL.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.INTERNAL.key,
    key: FORM_KEYS.INTERNAL.key,
    formConfig: { ...INPUT_MAP[FORM_KEYS.INTERNAL.key] },
    style: { width: '5rem', ...flexStyle },
  },
  {
    title: (
      <div className="col-title">
        <span>{FORM_KEYS.CLIENT.label}</span>
      </div>
    ),
    dataIndex: FORM_KEYS.CLIENT.key,
    key: FORM_KEYS.CLIENT.key,
    formConfig: { ...INPUT_MAP[FORM_KEYS.CLIENT.key] },
    style: { width: '5rem', ...flexStyle },
    // style: { flexShrink: 1 },
  },
];

export const generateGroupColumn = (
  groupName,
  groupId,
  isPureClientGroup,
  isEmptyGroup,
) => ({
  title: (
    <div className="col-title group-title">
      <Tooltip
        title={groupName}
        overlayClassName="group-title-cell-tooltip"
        align={{
          overflow: { adjustX: false, adjustY: true, alwaysByViewport: true },
        }}
      >
        {groupName}
      </Tooltip>
    </div>
  ),
  dataIndex: FORM_KEYS.GROUP.key,
  key: groupId,
  formConfig: {
    ...INPUT_MAP[FORM_KEYS.GROUP.key],
    groupId,
    isPureClientGroup,
    isEmptyGroup,
  },
  style: { width: '5rem', ...flexStyle },
});

export const getDefaultRowData = (data = {}) => ({
  [FORM_KEYS.ICON.key]: '',

  [FORM_KEYS.IFRAME.key]: false,
  ...data,
});
